import type { ReportValueType } from '~/presentation/reports/common/type';
import type { ReportColumnLayout } from '../../../types';

import { GInlineCenter } from '~/presentation/ui';
import { PreviousCell } from './PreviousCell';

interface WrapperCellProps {
  children: React.ReactNode;
  previousValue?: ReportValueType;
  isMergedWithPrev: boolean;
  columnLayout?: ReportColumnLayout;
}
export const WrapperCell: React.FC<WrapperCellProps> = ({
  children,
  previousValue,
  isMergedWithPrev,
  columnLayout,
}) => {
  return (
    <GInlineCenter
      flexDirection="column"
      align={columnLayout?.align}
      gap="100"
      paddingBlock="200"
      width={columnLayout?.columnWrapperWidth}
    >
      {children}
      <PreviousCell previousValue={previousValue} isMergedWithPrev={isMergedWithPrev} />
    </GInlineCenter>
  );
};
